import React from 'react';
import { Box } from '@mui/material';
import { ProjectSettingsMap } from '../../../../models/batchProjectUpload';
import { DetectedProject } from '../../../../utils/projectDetection';
import ProjectCard from './ProjectCard';

interface ProjectListProps {
  projects: DetectedProject[];
  selectedProjects: Set<string>;
  expandedProjects: Set<string>;
  projectSettings: ProjectSettingsMap;
  isUploading: boolean;
  onToggleSelect: (folderPath: string) => void;
  onToggleExpand: (folderPath: string) => void;
  onDescriptionChange: (folderPath: string, description: string) => void;
  onRendersFolderChange: (folderPath: string, folderName: string) => void;
}

const ProjectList: React.FC<ProjectListProps> = ({
  projects,
  selectedProjects,
  expandedProjects,
  projectSettings,
  isUploading,
  onToggleSelect,
  onToggleExpand,
  onDescriptionChange,
  onRendersFolderChange,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {projects?.map((project) => {
        const isSelected = selectedProjects.has(project.folderPath);
        const isExpanded = expandedProjects.has(project.folderPath);
        const settings = projectSettings[project.folderPath] || {};

        return (
          <ProjectCard
            key={project.folderPath}
            project={project}
            settings={settings}
            isSelected={isSelected}
            isExpanded={isExpanded}
            isUploading={isUploading}
            onToggleSelect={onToggleSelect}
            onToggleExpand={onToggleExpand}
            onDescriptionChange={onDescriptionChange}
            onRendersFolderChange={onRendersFolderChange}
          />
        );
      })}
    </Box>
  );
};

export default ProjectList;
